import React from "react";

import { cn } from "@racoon/ui";
import { Namespace, useT } from "@racoon/i18n";
import { IcCancel } from "@racoon/icons";

const WIDTHS = {
  md: "w-[113px]",
  sm: "w-[90px]",
  // the order form's photo card
  card: "w-[120px]",
} as const;

export interface InstructionPhotoThumbProps {
  src: string;
  onRemove?: () => void;
  size?: keyof typeof WIDTHS;
}

/**
 * One instruction photo preview with its remove badge. Deliberately unaware of
 * whether the photo is a local draft or already stored, so the upload modal and
 * the create/edit form all render an identical thumbnail — the design shows the
 * same one in each place, and separate copies are how they drift apart.
 */
export const InstructionPhotoThumb: React.FC<InstructionPhotoThumbProps> = ({
  src,
  onRemove,
  size = "md",
}) => {
  const t = useT();

  return (
    <div className={cn("relative shrink-0", WIDTHS[size])}>
      <img src={src} alt="" className="aspect-[3/2] w-full rounded-lg object-cover" />
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          aria-label={t(Namespace.Orders, "create.removePhoto")}
          className={cn(
            "absolute rounded-full bg-white leading-none hover:opacity-90",
            size === "card"
              ? "-right-3 -top-3 text-[#151a24]"
              : "-right-1.5 -top-1.5 text-brand-red",
          )}
        >
          <IcCancel className={size === "card" ? "h-6 w-6" : "h-5 w-5"} />
        </button>
      )}
    </div>
  );
};
